import React from 'react'
import clsx from 'clsx'

export type TypeaheadListboxProps = {
  id: string
  className?: string
  listRef?: React.RefObject<HTMLDivElement | null>
  children: React.ReactNode
}

/**
 * Portaled or inline suggestions panel for typeahead. Keeps listbox chrome consistent across flows.
 */
export const TypeaheadListbox: React.FC<TypeaheadListboxProps> = ({ id, className, listRef, children }) => (
  <div id={id} ref={listRef} className={clsx(className)} role="listbox">
    {children}
  </div>
)
